module.exports = __webpack_public_path__ + "static/media/loader.86b303e8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/loader.gif
// module id = 18
// module chunks = 0